export default "__VITE_ASSET__DHeUMKrL__"